<template>
  <div>
    <!-- Header -->
    <div class="content-header row">
      <div class="content-header-left col-md-6 col-12 mb-2">
        <div class="row breadcrumbs-top">
          <div class="breadcrumb-wrapper col-12">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Inicio</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'catalogo' }">Catálogo</router-link>
              </li>
              <li class="breadcrumb-item active">Tipos de Empresas</li>
            </ol>
          </div>
        </div>
        <h3 class="content-header-title mb-0">Gestión de Tipos de Empresas</h3>
      </div>
      <div class="content-header-right col-md-6 col-12">
        <div class="btn-group float-md-right" role="group">
          <b-button
            variant="primary"
            @click="showModal = true"
            v-b-modal.modal-tipo-empresa
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nuevo Tipo
          </b-button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Lista de Tipos de Empresas</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <!-- Indicador de carga -->
              <div v-if="cargando" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
                <p class="mt-2">Cargando tipos de empresas...</p>
              </div>
              
              <!-- Tabla de datos -->
              <div v-else class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="tiposEmpresas.length === 0">
                      <td colspan="3" class="text-center py-4">
                        <p class="text-muted">No hay tipos de empresas registrados</p>
                      </td>
                    </tr>
                    <tr v-for="tipo in tiposEmpresas" :key="tipo.idTipoEmpresa">
                      <td>{{ tipo.idTipoEmpresa }}</td>
                      <td>{{ tipo.nombre }}</td>
                      <td>
                        <b-button
                          variant="outline-primary"
                          size="sm"
                          @click="editarTipo(tipo)"
                          class="mr-1"
                        >
                          <feather-icon icon="EditIcon" size="14" />
                        </b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="eliminarTipo(tipo.idTipoEmpresa)"
                        >
                          <feather-icon icon="TrashIcon" size="14" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <b-modal
      id="modal-tipo-empresa"
      :title="modoEdicion ? 'Editar Tipo de Empresa' : 'Nuevo Tipo de Empresa'"
      @ok="guardarTipo"
      @cancel="limpiarFormulario"
      :ok-disabled="guardando"
      :cancel-disabled="guardando"
    >
      <b-form @submit.prevent="guardarTipo">
        <b-form-group label="Nombre:" label-for="nombre">
          <b-form-input
            id="nombre"
            v-model="formulario.nombre"
            placeholder="Ingrese el nombre del tipo de empresa"
            :disabled="guardando"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>
      
      <!-- Indicador de carga en el modal -->
      <div v-if="guardando" class="text-center py-2">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="sr-only">Guardando...</span>
        </div>
        <span class="ml-2">Guardando...</span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import { CatalogoTiposEmpresasMixin } from '@/@core/mixins/catalogos'

export default {
  name: 'CatalogoTiposEmpresas',
  components: {
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  mixins: [CatalogoTiposEmpresasMixin],
}
</script>


















